import React from "react";
import ImageUploadField from "./ImageUploadField";

/*
  Business Website manager — "Home" tab (CR B1).
  Business details + logo/cover (direct upload, CR B2/B4) + YouTube link (CR B6).
*/
export default function BizHomeTab({ form, set, personaluid }) {
    return (
        <>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Business Details</div>
                <div className="card-body"><div className="row g-2">
                    <div className="col-md-6"><label className="form-label small">Business Name *</label><input className="form-control form-control-sm" value={form.name} onChange={(e) => set("name", e.target.value)} /></div>
                    <div className="col-md-6"><label className="form-label small">Tagline</label><input className="form-control form-control-sm" value={form.tagline} onChange={(e) => set("tagline", e.target.value)} /></div>
                    <div className="col-md-6"><label className="form-label small">Phone</label><input className="form-control form-control-sm" value={form.phone} onChange={(e) => set("phone", e.target.value)} /></div>
                    <div className="col-md-6"><label className="form-label small">Email</label><input className="form-control form-control-sm" value={form.email} onChange={(e) => set("email", e.target.value)} /></div>
                    <div className="col-md-6"><label className="form-label small">Address</label><input className="form-control form-control-sm" value={form.address} onChange={(e) => set("address", e.target.value)} /></div>
                    <div className="col-md-6"><label className="form-label small">Website URL</label><input className="form-control form-control-sm" value={form.website} onChange={(e) => set("website", e.target.value)} /></div>

                    <div className="col-md-6">
                        <label className="form-label small">Logo</label>
                        <ImageUploadField value={form.logo} onChange={(v) => set("logo", v)} purpose="logo" personaluid={personaluid} placeholder="Upload logo" />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label small">Homepage Background / Cover Image</label>
                        <ImageUploadField value={form.cover} onChange={(v) => set("cover", v)} purpose="cover" personaluid={personaluid} placeholder="Upload cover image" />
                    </div>

                    <div className="col-12"><label className="form-label small">About / Description</label><textarea rows="3" className="form-control form-control-sm" value={form.about} onChange={(e) => set("about", e.target.value)} /></div>
                </div></div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">YouTube Video</div>
                <div className="card-body">
                    <label className="form-label small">YouTube Video Link</label>
                    <input
                        className="form-control form-control-sm"
                        placeholder="https://www.youtube.com/watch?v=..."
                        value={form.youtube_link}
                        onChange={(e) => set("youtube_link", e.target.value)}
                    />
                    <div className="form-text">Only one YouTube link per profile — a link, not an uploaded video file.</div>
                </div>
            </div>
        </>
    );
}
